import { config } from '@utility/config';
import { BrowserUtility } from '@utility/browser-utility';
import { CommonConstant } from '@utility/constants/common';
import { BaseService } from './base';
class Health {
  checkHealth = () =>
    BaseService.getV2(
      '/health',
      false,
      `${
        BrowserUtility.get(CommonConstant.useProd)
          ? config.prodAPIPath
          : config.apiPath
      }`,
      false,
    );
}

const HealthService = new Health();
Object.freeze(HealthService);
export default HealthService;
